import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Banner from '../common/Banner';
import SideNavbar from '../layout/SideNavbar';
import Navbar from '../layout/Navbar';
import {
  getSettings,
  addAdmin,
  deleteAdmin,
  clearErrors,
  toggleNewCompanyNotification,
  toggleNewProductNotification,
} from '../../actions/authActions';
import {
  getInfos,
  createInfo,
  editInfo,
  deleteInfoByID,
  clearInfoErrors,
} from '../../actions/infoActions';
import {
  getHomeImages,
  createHomeImage,
  deleteHomeImage,
} from '../../actions/homeImageActions';
import Spinner from '../common/Spinner';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import isEmpty from '../../validation/is-empty';

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      admin: '',
      page: 'company',
      lang: 'fi',
      name: '',
      text: '',
      homeImageFile: null,
      companyNotification: true,
      productNotification: true,
      uploadMessage: '',
      errors: {},
    };
  }

  componentDidMount() {
    document.title = this.props.intl.formatMessage({
      id: 'settings.title',
    });
    this.props.clearErrors();
    this.props.getSettings();
    this.props.getInfos();
    this.props.getHomeImages();
  }

  static getDerivedStateFromProps(props, state) {
    if (props.errors !== state.errors) {
      return { errors: props.errors };
    }
    if (
      props.auth.settings.newCompanyNotification !==
      state.companyNotification ||
      props.auth.settings.newProductNotification !== state.productNotification
    ) {
      return {
        productNotification: props.auth.settings.newProductNotification,
        companyNotification: props.auth.settings.newCompanyNotification,
      };
    }
    return null;
  }

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  onCheckboxChange = (e) => {
    this.props.toggleNewCompanyNotification();
    this.setState({
      companyNotification: !this.state.companyNotification,
    });
  };

  onCheckboxChangeProduct = (e) => {
    this.props.toggleNewProductNotification();
    this.setState({
      productNotification: !this.state.productNotification,
    });
  };

  onSubmit = (e) => {
    e.preventDefault();
    const userData = {
      email: this.state.admin,
      locale: this.props.locale.lang,
    };
    this.props.clearErrors();
    this.props.addAdmin(userData);
    this.setState({ admin: '' });
  };

  onInfoSubmit = (e) => {
    e.preventDefault();
    const infoData = {
      page: this.state.page,
      lang: this.state.lang,
      name: this.state.name,
      text: this.state.text,
      locale: this.props.locale.lang,
    };
    this.props.clearInfoErrors();
    this.props.createInfo(infoData);
    this.setState({ name: '', text: '' });
  };

  onHomeImageSubmit = (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append('home', this.state.homeImageFile);
    data.append('locale', this.props.locale.lang);

    this.props.createHomeImage(data);
    this.setState({ homeImageFile: null, uploadMessage: '' });
  };

  onDelete = (id, email) => {
    const userData = {
      id,
      locale: this.props.locale.lang,
    };
    let message = '';
    if (email === this.props.auth.user.email) {
      if (this.props.locale.lang === 'en')
        message = 'Are you sure? You will be logged out.';
      else message = 'Oletko varma? Sinut kirjaudut ulos.';
      if (window.confirm(message)) {
        this.props.deleteAdmin(userData, true);
      }
    } else {
      this.props.deleteAdmin(userData, false);
    }
  };

  onFileSelect = (event) => {
    this.setState({
      homeImageFile: event.target.files[0],
      uploadMessage: event.target.value.replace('C:\\fakepath\\', ''),
    });
  };

  onInfoDelete = (id) => {
    this.props.deleteInfoByID(id);
  };

  onHomeImageDelete = (id) => {
    this.props.deleteHomeImage(id);
  };

  render() {
    const { settings, loading } = this.props.auth;
    const { infos } = this.props.info;
    const { homeImages } = this.props.homeImage;
    const { errors, uploadMessage } = this.state;

    let settingsContent;
    let infosContent;
    let homeImagesContent;
    let adminList = [];
    let infoList = [];
    let homeImageList = [];

    if (isEmpty(settings) || loading) {
      settingsContent = <Spinner />;
    } else {
      adminList = settings.admins.map((item) => {
        return (
          <li
            key={item._id}
            className="list-group-item d-flex justify-content-between align-items-center"
          >
            {item.email}
            <button onClick={() => this.onDelete(item._id, item.email)}>
              <span className="badge delete-button text-danger badge-pill mt-0">
                <i className="lni-trash" />
              </span>
            </button>
          </li>
        );
      });

      settingsContent = (
        <div>
          <div className="row mb-4">
            <div className="col-10">
              <h3 className="settings-title">New company notification:</h3>
            </div>
            <div className="col-2">
              <div className="settings">
                <input
                  name="companyNotification"
                  type="checkbox"
                  checked={this.state.companyNotification}
                  onChange={this.onCheckboxChange}
                />
              </div>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-10">
              <h3 className="settings-title">New product notification:</h3>
            </div>
            <div className="col-2">
              <div className="settings">
                <input
                  name="productNotification"
                  type="checkbox"
                  checked={this.state.productNotification}
                  onChange={this.onCheckboxChangeProduct}
                />
              </div>
            </div>
          </div>
          <h3 className="property-title">
            <FormattedMessage id="settings.adminList" />
          </h3>
          <ul className="list-group">{adminList}</ul>
          <div className="search-add">
            <form onSubmit={this.onSubmit} className="mt-2">
              <div className="form-group">
                <FormattedMessage id="settings.addNewAdmin">
                  {(addNewAdmin) => (
                    <input
                      placeholder={addNewAdmin}
                      name="admin"
                      type="text"
                      value={this.state.admin}
                      onChange={this.onChange}
                      className={classnames('form-control-search', {
                        'is-invalid': errors.email,
                      })}
                    />
                  )}
                </FormattedMessage>
                <div className="arrow-left-catalog" />
                <button type="submit" className="search-btn">
                  <span className="lni-plus" />
                </button>
                {errors.email && (
                  <div
                    className="invalid-feedback"
                    style={{ display: 'block' }}
                  >
                    {errors.email}
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      );
    }

    if (isEmpty(infos) || this.props.info.loading) {
      infosContent = <Spinner />;
    } else {
      infoList = infos.map((item) => {
        return (
          <li
            key={item._id}
            className="list-group-item d-flex justify-content-between align-items-center"
          >
            {item.page} | {item.lang} | {item.name} | {item.text}
            <button onClick={() => this.onInfoDelete(item._id)}>
              <span className="badge delete-button text-danger badge-pill mt-0">
                <i className="lni-trash" />
              </span>
            </button>
          </li>
        );
      });

      infosContent = <ul className="list-group">{infoList}</ul>;
    }

    if (isEmpty(homeImages) || this.props.homeImage.loading) {
      homeImagesContent = <Spinner />;
    } else {
      homeImageList = homeImages.map((item) => {
        return (
          <li
            key={item._id}
            className="list-group-item d-flex justify-content-between align-items-center"
          >
            <img src={item.photo} className="carousel-preview" alt="Carousel preview" />
            <button onClick={() => this.onHomeImageDelete(item._id)}>
              <span className="badge delete-button text-danger badge-pill mt-0">
                <i className="lni-trash" />
              </span>
            </button>
          </li>
        );
      });

      homeImagesContent = <ul className="list-group">{homeImageList}</ul>;
    }

    return (
      <div>
        <Navbar />
        <FormattedMessage id="settings.settings">
          {(settings) => <Banner pageName={settings} />}
        </FormattedMessage>
        <section className="user-page section-padding">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-5 col-xs-12">
                <SideNavbar />
              </div>
              <div className="col-lg-8 col-md-7 col-xs-12">
                <div className="dashborad-box">
                  <h4 className="title">
                    <FormattedMessage id="settings.settings" />
                  </h4>
                  <div className="property-wrap">
                    <div className="property-item">
                      <div className="item-body">
                        <div className="row justify-content-center">
                          <div className="col-lg-8 col-md-8 col-xs-12">
                            {settingsContent}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dashborad-box">
                  <h4 className="title">
                    <FormattedMessage id="settings.infos" />
                  </h4>
                  <div className="property-wrap">
                    <div className="property-item">
                      {infosContent}
                      <form onSubmit={this.onInfoSubmit}>
                        <div className="form-group mt-4">
                          <div className="row infos">
                            <div className="col-md-3 pl-0">
                              <select
                                className="form-control classic"
                                onChange={this.onChange}
                                name="page"
                              >
                                <option key="company" value="company">
                                  Company
                                </option>
                                <option key="product" value="product">
                                  Product
                                </option>
                              </select>
                            </div>
                            <div className="col-md-2 pl-0">
                              <select
                                className="form-control classic"
                                onChange={this.onChange}
                                name="lang"
                              >
                                <option key="fi" value="fi">
                                  Fi
                                </option>
                                <option key="en" value="en">
                                  En
                                </option>
                              </select>
                            </div>
                            <div className="col-md-2 p-0">
                              <input
                                placeholder="Field name"
                                name="name"
                                type="text"
                                value={this.state.name}
                                onChange={this.onChange}
                                className={classnames('form-control', {
                                  'is-invalid': errors.name,
                                })}
                              />
                            </div>
                            <div className="col-md-5 pr-0 search-add">
                              <input
                                placeholder="Text"
                                name="text"
                                type="text"
                                value={this.state.text}
                                onChange={this.onChange}
                                className={classnames('form-control-search', {
                                  'is-invalid': errors.text,
                                })}
                              />
                              <div className="arrow-left-catalog" />
                              <button type="submit" className="search-btn">
                                <span className="lni-plus" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="dashborad-box">
                  <h4 className="title">
                    <FormattedMessage id="settings.homeImages" />
                  </h4>
                  <div className="property-wrap">
                    <div className="property-item">
                      {homeImagesContent}
                      <form onSubmit={this.onHomeImageSubmit}>
                        <div className="form-group mt-4">
                          <div className="row">
                            <div className="col-md-6 offset-3 search-add d-inline-flex">
                              <div className="custom-file">
                                <input
                                  type="file"
                                  className="custom-file-input"
                                  id="customFile"
                                  onChange={this.onFileSelect}
                                  ref={(ref) => (this.fileUpload = ref)}
                                />
                                <label
                                  className="custom-file-label"
                                  htmlFor="customFile"
                                  style={{ borderBottomRightRadius: 0, borderBottomLeftRadius: 0 }}
                                >
                                  {uploadMessage ? (
                                    uploadMessage
                                  ) : (
                                    <FormattedMessage id="settings.uploadhomeImage" />
                                  )}
                                </label>
                              </div>
                              <button type="submit" className="search-btn">
                                <span className="lni-plus" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

Settings.propTypes = {
  getSettings: PropTypes.func.isRequired,
  addAdmin: PropTypes.func.isRequired,
  deleteAdmin: PropTypes.func.isRequired,
  getInfos: PropTypes.func.isRequired,
  createInfo: PropTypes.func.isRequired,
  editInfo: PropTypes.func.isRequired,
  deleteInfoByID: PropTypes.func.isRequired,
  createHomeImage: PropTypes.func.isRequired,
  deleteHomeImage: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  clearInfoErrors: PropTypes.func.isRequired,
  toggleNewCompanyNotification: PropTypes.func.isRequired,
  toggleNewProductNotification: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  info: state.info,
  homeImage: state.homeImage,
  errors: state.errors,
  locale: state.locale,
});

export default connect(mapStateToProps, {
  getSettings,
  addAdmin,
  deleteAdmin,
  getInfos,
  createInfo,
  editInfo,
  deleteInfoByID,
  getHomeImages,
  createHomeImage,
  deleteHomeImage,
  toggleNewCompanyNotification,
  toggleNewProductNotification,
  clearErrors,
  clearInfoErrors,
})(injectIntl(Settings));
